import { ModalConstant } from '../constants';

export const closeModal = payload => ({
  payload,
  type: ModalConstant.CLOSE_MODAL,
});

export const openModal = payload => ({
  payload,
  type: ModalConstant.OPEN_MODAL,
});
